import * as utils from "common/utils";
export default function GhgTotalEmissions({ ghgResults, title = "Total farm emissions" }) {
    if (!ghgResults) return null;

    const totalMethaneEmissions = ghgResults?.emissions?.methane?.totalEmissions;
    const totalNitrousOxideEmissions = ghgResults?.emissions?.nitrousOxide?.totalEmissions;
    const totalCarbonDioxideEmissions = ghgResults?.emissions?.carbonDioxide?.totalEmissions;
    const totalEmissions = ghgResults?.emissions?.totalEmissions;

    return (
        <div className="HeroPanel u-mt-md u-page-break u-print-border">
            <div className="HeroPanel-title">{title}</div>
            <div className="Table u-mt-0 u-mb-md">
                <table>
                    <thead>
                        <tr>
                            <th>Total farm emissions in tonnes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="HeroValue">
                                    <div className="HeroValue-item">
                                        <h5>Methane</h5>
                                        <div className="u-flex u-flexColumn">
                                            <span id="methane-emissions" className="h1">
                                                {utils.numeric.format(totalMethaneEmissions?.value, 1)} <small>{totalMethaneEmissions?.unit?.notation}</small>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="HeroValue-item">
                                        <h5>Nitrous oxide</h5>
                                        <div className="u-flex u-flexColumn">
                                            <span id="n2O-emissions" className="h1">
                                                {utils.numeric.format(totalNitrousOxideEmissions?.value, 1)} <small>{totalNitrousOxideEmissions?.unit?.notation}</small>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="HeroValue-item">
                                        <h5>Carbon dioxide</h5>
                                        <div className="u-flex u-flexColumn">
                                            <span id="cO2-emissions" className="h1">
                                                {utils.numeric.format(totalCarbonDioxideEmissions?.value, 1)} <small>{totalCarbonDioxideEmissions?.unit?.notation}</small>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="HeroValue-item">
                                        <h5>Total GHG emissions</h5>
                                        <div className="u-flex u-flexColumn">
                                            <span id="total-emissions" className="h1">
                                                {utils.numeric.format(totalEmissions?.value, 1)} <small>{totalCarbonDioxideEmissions?.unit?.notation}</small>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
